import React from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import './PillNav.scss';

const NavAsPills: React.FC<PillNavProps> = (props) => (
    <ul className="nav nav-pills" role="tablist">           
        {props.children.map((child: any, i: number) => 
            <li className="nav-item" key={i}>
                {child}
            </li>
        )}
    </ul>
)

const NavAsDropdown: React.FC<PillNavProps> = (props) => (
    
    <DropdownButton id={props.id} title={props.text ?? ""} variant={null}>      
         {props.children.map((child: any, i: number) => 
            <Dropdown.Item key={i}>
                {child}
            </Dropdown.Item>
        )}
    </DropdownButton>
)

export interface PillNavProps {
    text: string;
    children: any;
    id: string;
}

export const PillNav: React.FC<PillNavProps> = (props) => <div className="pill-nav">
    <div className="d-none d-lg-inline">
        <NavAsPills {...props} />
    </div>
    <div className="d-inline d-lg-none">
        <NavAsDropdown {...props} />
    </div>
</div>